/*
 * @params {Boolean} reload 表示倒计时结束时是否刷新页面
 * @params {Func} onCountEnd 倒计时结束时触发的回调
 * @params {String} time 倒计时的时间
 * @params {Boolean} flag 表示是否显示天数
 * @params {Boolean} text 表示输出只有文字的格式，没有白底框
 */
import React, { Component } from 'react';
import { Flex } from 'antd-mobile';
import util from 'utils';
import './RedEnvelopeRainLess.less';
import { divide } from 'lodash';

/**
 * 默认颜色是白底，红字（主题色）（首页例子）
 */
class RainCountDown extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      // 倒计时, 字符串2018-10-10 10:00:00 或 倒计时差，秒
      countdownTime: this.props.time,
      date: '00',
      hour: '00',
      min: '00',
      sec: '00'
    };
    this.clearTimeMethod = null;
  }

  componentDidMount() {
    // reload 表示倒计时结束时是否刷新页面
    // onCountEnd为倒计时结束时触发的回调
    const { countdownTime } = this.state;
    const { reload, onCountEnd } = this.props;

    const data = util.getCountDown(util.exchangeTime(countdownTime), this.props.flag);
    const { date, hour, min, sec } = data;
    if (+date === 0 && +hour === 0 && +min === 0 && +sec === 0) {
      return;
    }

    const timer = setInterval(() => {
      this.countDown(reload, onCountEnd);
    }, 1000);

    this.clearTimeMethod = timer;
  }

  componentWillReceiveProps(nextProps) {
    // console.log('111111111111',nextProps,this.state.countdownTime);
    // this.setState({ countdownTime: nextProps.time });
  }

  componentWillUnmount() {
    clearInterval(this.clearTimeMethod);
  }

  countDown(reload, cb) {
    const { countdownTime } = this.state;
    let curtTime = countdownTime;

    // 兼容iosDate构造函数不识别'YYYY-MM-DD'的问题
    const data = util.getCountDown(util.exchangeTime(countdownTime), this.props.flag);
    const { date, hour, min, sec } = data;
    if (+date === 0 && +hour === 0 && +min === 0 && +sec === 0) {
      reload && window.location.reload();
      cb && cb();
    } else {
      if (typeof countdownTime == 'number') {
        curtTime = countdownTime - 1;
      }
    }

    this.setState({
      countdownTime: curtTime,
      ...data
    });
  }

  render() {
    // text表示输出只有文字的格式，没有白底框，format数组长度最长为4，分别渲染 '天时分秒' 的后缀部分
    const { className, text, colorType, format = [] } = this.props;
    const { hour, min, sec, date } = this.state;
    let _date = '';
    if (date > 0 && date < 10) {
      _date = '0' + date;
    } else {
      _date = date;
    }
    if (+date === 0 && +hour === 0 && +min === 0 && +sec === 0) {
      return <div></div>;
    }

    return (
      <Flex className={`red-common-count-down ${className} ${text ? '' : 'format'}`}>
        {this.props.flag ? (
          date > 0 ? (
            <React.Fragment>
              <span className="date">{_date}</span>
              <span className="day">{format[0] || '天'}</span>
            </React.Fragment>
          ) : null
        ) : null}
        <span className={`hour ${colorType} ${format.length >= 1 ? '' : 'dot'}`}>{hour}</span>
        <span className="colon">{format[1] || ':'}</span>
        <span className={`min ${colorType} ${format.length >= 1 ? '' : 'dot'}`}>{min}</span>
        <span className="colon">{format[2] || ':'}</span>
        <span className={`sec ${colorType} ${format.length >= 1 ? '' : 'dot'}`}>{sec}</span>
        <span className="colon">{format[3] || ''}</span>
      </Flex>
    );
  }
}

module.exports = RainCountDown;



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/RedEnvelopeRain/RainCountDownView.js